<script setup lang="ts">
import { DownloadIcon } from '@heroicons/vue/outline';
</script>

<template>
  <button
    type="submit"
    class="mt-2 text-gray-500 hover:text-primary hover:disabled:text-gray-500"
  >
    <DownloadIcon class="h-5 w-5" />
  </button>
</template>
